export default "__VITE_ASSET__BU0G6p$C__"